import { createServerFn } from "@tanstack/react-start"
import { getWeeks } from "../lib/db"
import { buildWeekScheduleMap, getCurrentWeekKey, type WeekSchedule } from "../lib/schedule"

export const scheduleGet = createServerFn().handler(async () => {
  const weeksFile = getWeeks()
  const { weeks, weekKeys } = buildWeekScheduleMap(weeksFile)
  const weeksRecord: Record<string, WeekSchedule> = {}
  for (const [k, v] of weeks) {
    weeksRecord[k] = v
  }
  return { weekKeys, weeksRecord, currentWeekKey: getCurrentWeekKey() }
})
